import { RefreshCw, Shield } from "lucide-react";
import { Select } from "./Select";

const mapOptions = (values = []) =>
  values.map((value) =>
    typeof value === "object" ? value : { value, label: value || "" }
  );

const TeamsView = ({
  teams,
  filters,
  onFilterChange,
  leagues,
  seasons,
  conferences,
  loading,
  onRefresh,
  pagination,
  onPageChange,
  t
}) => (
  <div className="space-y-6">
    <div className="border border-white/10 rounded-sm overflow-hidden bg-white/[0.02]">
      <div className="p-6 border-b border-white/10 flex items-center justify-between">
        <h2 className="text-2xl font-black uppercase tracking-tight text-white flex items-center gap-3">
          {t("Teams")} ({teams.length})
        </h2>
        {pagination?.totalPages > 1 && (
          <span className="text-[11px] font-mono uppercase tracking-[0.3em] text-gray-500">
            {t("Page")} {pagination.currentPage} {t("of")} {pagination.totalPages}
          </span>
        )}
      </div>

      {loading ? (
        <div className="p-12 text-center">
          <RefreshCw className="animate-spin mx-auto mb-4 text-white" size={32} />
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-gray-400">
            {t("Loading teams...")}
          </p>
        </div>
      ) : teams.length === 0 ? (
        <div className="p-12 text-center">
          <Shield className="mx-auto mb-4 text-gray-600" size={36} />
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-gray-500">
            {t("No teams found")}
          </p>
        </div>
      ) : (
        <>
          <div className="p-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {teams
              .slice(
                pagination
                  ? (pagination.currentPage - 1) * pagination.perPage
                  : 0,
                pagination
                  ? pagination.currentPage * pagination.perPage
                  : teams.length
              )
              .map((team) => (
                <div
                  key={team.id}
                  className="border border-white/10 rounded-sm p-4 bg-black/40 space-y-3"
                >
                  <div className="flex items-center gap-3">
                    {team.logo && (
                      <img
                        src={team.logo}
                        alt={team.name}
                        className="w-12 h-12 object-contain border border-white/10 rounded-sm bg-black"
                      />
                    )}
                    <div>
                      <p className="text-lg font-black uppercase text-white">{team.name}</p>
                      <p className="text-[11px] text-gray-500 uppercase tracking-widest">
                        {team.conference} {team.division ? `• ${team.division}` : ""}
                      </p>
                    </div>
                  </div>
                  <div className="text-sm text-gray-400">
                    {team.city && <p>{team.city}</p>}
                    {team.stadium && <p>{team.stadium}</p>}
                  </div>
                  <div className="text-[11px] font-mono uppercase tracking-widest text-gray-500">
                    {t("Code")}: {team.code || "—"}
                  </div>
                </div>
              ))}
          </div>

          {pagination?.totalPages > 1 && (
            <div className="border-t border-white/10 flex items-center justify-center gap-3 px-6 py-4">
              <button
                onClick={() => onPageChange(pagination.currentPage - 1)}
                disabled={pagination.currentPage === 1}
                className="px-3 py-2 border border-white/10 text-white text-xs font-mono uppercase tracking-widest rounded-sm bg-transparent hover:border-white/30 disabled:opacity-40 transition-all"
              >
                {t("Prev")}
              </button>
              <span className="text-xs font-mono uppercase tracking-[0.3em] text-gray-400">
                {pagination.currentPage} / {pagination.totalPages}
              </span>
              <button
                onClick={() => onPageChange(pagination.currentPage + 1)}
                disabled={pagination.currentPage === pagination.totalPages}
                className="px-3 py-2 border border-white/10 text-white text-xs font-mono uppercase tracking-widest rounded-sm bg-transparent hover:border-white/30 disabled:opacity-40 transition-all"
              >
                {t("Next")}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  </div>
);

export default TeamsView;
